import { useQuery } from '@tanstack/react-query';

import { FlightCampaignType, getFlightCampaigns } from '~/services/FlightsService';

export const FLIGHT_CAMPAIGNS_QUERY_KEY = 'flightCampaigns';

export function useFlightCampaigns(filters: { type?: FlightCampaignType } = {}) {
  const {
    data = [],
    isLoading: loading,
    error,
    refetch,
  } = useQuery<Array<App.FlightCampaign>, Error>({
    queryKey: [FLIGHT_CAMPAIGNS_QUERY_KEY, filters.type],
    queryFn: async () => {
      const { result } = await getFlightCampaigns({ type: filters.type });
      return result.rows;
    },
  });

  return { loading, error, data, revalidate: refetch };
}
